export function getIframes(target = window.parent) {
  const frames = [];
  for (let i = 0; i < target.frames.length; i++) {
    try {
      const frame = target.frames[i];
      // eslint-disable-next-line no-unused-expressions
      frame.document; // cross-origin iframes will throw error and won't be included
      frames.push(frame);
    } catch (e) {}
  }

  return frames;
}
